document.addEventListener("DOMContentLoaded", () => {

  /* ------------------------------
     Open Craft Menu
  ------------------------------ */

  const menuButton = document.getElementById("mobile-bottom-menu");

  if(menuButton){

    menuButton.addEventListener("click",(e)=>{

      e.preventDefault();

      const drawer =
      document.querySelector("#Details-menu-drawer-container summary") ||
      document.querySelector("summary.header__icon--menu");

      if(drawer){
        drawer.click();
      }

    });

  }

  /* ------------------------------
     Hide on Scroll
  ------------------------------ */

  const nav=document.querySelector(".mobile-bottom-nav");

  if(nav){

    let lastScroll=0;

    window.addEventListener("scroll",()=>{

      const current=window.pageYOffset;

      if(current>lastScroll && current>80){

        nav.classList.add("hide-nav");

      }else{

        nav.classList.remove("hide-nav");

      }

      lastScroll=current;

    });

  }

});
/* ==========================
   LIVE CART BADGE - Craft 15.5
========================== */

async function updateMobileCartBadge() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const badge = document.getElementById('mobile-cart-count');

    if (!badge) return;

    if (cart.item_count > 0) {
      badge.textContent = cart.item_count;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }

  } catch (e) {
    console.log(e);
  }
}

// Initial load
updateMobileCartBadge();

/* Refresh after any AJAX cart request */
(function () {

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {

    const response = await originalFetch.apply(this, args);

    const url = args[0].toString();

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    ) {

      setTimeout(updateMobileCartBadge, 200);

    }

    return response;

  };

})();